import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { VENDOR_ORDER_PAYMENT_TABS } from 'utils/constants';
import CustomTabs from 'components/CustomTabs';
import ErrorBoundary from 'components/common/ErrorBoundary';
import PaymentUnPaid from './components/PaymentUnPaid';
// import PaymentFullyPaid from './components/PaymentFullyPaidTable';
import PaymentPartiallyPaid from './components/PaymentPartiallyPaid';

const VendorOrderPayment = () => {
  const [activeTab, setActiveTab] = useState(
    VENDOR_ORDER_PAYMENT_TABS.PARTIALLY_PAID,
  );
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {' '}
      <div className="d-flex align-items-center">
        <CustomTabs
          tabs={[
            VENDOR_ORDER_PAYMENT_TABS.PARTIALLY_PAID,
            VENDOR_ORDER_PAYMENT_TABS.FULLY_PAID,
            VENDOR_ORDER_PAYMENT_TABS.UNPAID,
          ]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="border-0 inner-list-tab"
        />
      </div>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={VENDOR_ORDER_PAYMENT_TABS.PARTIALLY_PAID}>
          {activeTab === VENDOR_ORDER_PAYMENT_TABS.PARTIALLY_PAID && (
            <ErrorBoundary>
              <PaymentPartiallyPaid />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={VENDOR_ORDER_PAYMENT_TABS.FULLY_PAID}>
          {activeTab === VENDOR_ORDER_PAYMENT_TABS.FULLY_PAID && (
            <ErrorBoundary>{/* <PaymentFullyPaid /> */}</ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={VENDOR_ORDER_PAYMENT_TABS.UNPAID}>
          {activeTab === VENDOR_ORDER_PAYMENT_TABS.UNPAID && (
            <ErrorBoundary>
              <PaymentUnPaid />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default VendorOrderPayment;
